import React, { useEffect, useState } from "react";
import { FileText, Download, Eye } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { api, fetchFileBlobUrl } from "@/lib/api";

export function ClientDocumentsSection() {
  const { t } = useLanguage();
  const [docs, setDocs] = useState(null);
  useEffect(() => { api.get("/me/documents").then(({ data }) => setDocs(data)).catch(() => setDocs([])); }, []);

  const open = async (id, download, fileName) => {
    const url = await fetchFileBlobUrl(id);
    if (download) {
      const a = document.createElement("a");
      a.href = url; a.download = fileName; a.click();
    } else {
      window.open(url, "_blank");
    }
  };

  if (docs === null) return <p className="px-5 py-8 text-center text-sm text-muted-foreground">…</p>;
  if (docs.length === 0) return <p className="px-5 py-12 text-center text-sm text-muted-foreground">{t("client.docs.empty")}</p>;

  return (
    <div className="px-5 py-5">
      <p className="text-sm text-muted-foreground">{t("client.docs.hint")}</p>
      <ul className="mt-4 divide-y divide-border">
        {docs.map((d) => (
          <li key={d.id} className="flex items-center gap-4 py-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent/10 text-accent"><FileText className="h-5 w-5" /></span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-foreground">{d.title}</p>
              <p className="truncate text-xs text-muted-foreground">{t(`docType.${d.docType}`)} · {d.fileName}</p>
            </div>
            <div className="flex gap-2">
              <Button size="sm" variant="outline" onClick={() => open(d.id, false, d.fileName)}><Eye className="h-4 w-4" />{t("client.docs.view")}</Button>
              <Button size="sm" variant="ghost" onClick={() => open(d.id, true, d.fileName)}><Download className="h-4 w-4" /></Button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
